import certificate1 from "assets/certificates/certificate1.pdf";
import certificate2 from "assets/certificates/certificate2.pdf";
import certificate3 from "assets/certificates/certificate3.pdf";
import certificate4 from "assets/certificates/certificate4.pdf";
import certificate5 from "assets/certificates/certificate5.pdf";

import html_css from "assets/images/html_css.png";
import js from "assets/images/js.png";
import reactjs from "assets/images/reactjs.png";
import python from "assets/images/python.png";
import node from "assets/images/nodejs.png";

export const educationData = [
  {
    title: "Full Stack Development - Node JS",
    school: "Academy of Digital Industries",
    date: "17/03/2026",
    img: node,
    pdf: certificate5,
  },
  {
    title: "Full Stack Development - Python",
    school: "Academy of Digital Industries",
    date: "02/05/2025",
    img: python,
    pdf: certificate4,
  },
  {
    title: "Frontend Development - React JS",
    school: "Academy of Digital Industries",
    date: "07/02/2025",
    img: html_css,
    pdf: certificate3,
  },
  {
    title: "Frontend Development - JavaScript",
    school: "Academy of Digital Industries",
    date: "12/12/2024",
    img: js,
    pdf: certificate2,
  },
  {
    title: "Frontend Development - HTML & CSS",
    school: "Academy of Digital Industries",
    date: "19/08/2024",
    img: reactjs,
    pdf: certificate1,
  },
  {
    title: "Business Administration",
    school: "Tbilisi State University",
    date: "2019 - 2023",
    img: null,
    pdf: null,
  },
];
